module.exports = __webpack_public_path__ + "img/04-27-176.dfb931a5.png";